import { Component } from 'react';
import Button from "../../Buttons/Button";
import "./SideBarFooter.scss";

class SideBarFooter extends Component {
	state = {previewLoading: false}
	render() {
		const { saving, publishEnabled, publish, publishOverride, publishing, preview, previewLoading, requiresReview, publishWithoutReviewEnabled, fixed, disabled, isClone} = this.props;
		// Badged (clone) portfolios publish automatically with their master, so Publish is disabled for them.
		// Clones are normally hidden from the fund dropdown; this guard + tooltip covers the deep-link case.
		// The tooltip lives on the wrapping span because a disabled button doesn't reliably show a native title.
		const cloneTooltip = "Badged versions are published automatically when their master portfolio is published.";
		return (
			<div className={`sidebar-footer${fixed ? ' fixed' : ''}`}>
				<div className="sidebar-footer-content border-default-top">
					<div className="sidebar-footer-buttons">
						<Button fullWidth onClick={preview} className={`mb-m ${saving ? " button-saving" : ""}`}  disabled={previewLoading || disabled} variant="secondary">{previewLoading ? <><div className="sp-circle" /> Generating</> : "Preview" }</Button>
						<span title={isClone ? cloneTooltip : undefined} style={{ display: 'block' }}>
							<Button fullWidth onClick={publish} variant="positive" disabled={!publishEnabled || publishing || disabled || isClone}>{publishing ? <><div className="sp-circle" />Publishing ...</> : "Publish"}</Button>
						</span>
					</div>
					{/* Footer buttons */}
					{requiresReview && <Button fullWidth hover="default" variant="transparent" disabled={!publishWithoutReviewEnabled} className="mt-m" text="Publish without review" onClick={publishOverride}>Publish Without Review</Button>}
				</div>
			</div>
		);
	}
}

export default SideBarFooter;